import { render } from "./BaseBreadCrumb.vue?vue&type=template&id=656e2ce4&scoped=true"
import script from "./BaseBreadCrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadCrumb.vue?vue&type=script&lang=js"

import "./BaseBreadCrumb.vue?vue&type=style&index=0&id=656e2ce4&lang=scss&scoped=true"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656e2ce4"],['__file',"src/components/helpers/BaseBreadCrumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "656e2ce4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('656e2ce4', __exports__)) {
    console.log('reload')
    api.reload('656e2ce4', __exports__)
  }
  
  module.hot.accept("./BaseBreadCrumb.vue?vue&type=template&id=656e2ce4&scoped=true", () => {
    console.log('re-render')
    api.rerender('656e2ce4', render)
  })

}


export default __exports__